import { useMemo } from 'react';

import { useTranslation } from 'react-i18next';

import { GridColumns, GridValidRowModel } from '@mui/x-data-grid-pro';

export const useGetColumns = () => {
  const { t } = useTranslation('common');

  return useMemo<GridColumns<GridValidRowModel>>(
    () => [
      {
        headerName: t('poolMaintenance.column.code'),
        field: 'code',
        type: 'string',
        hideable: false,
        flex: 0
      },
      {
        headerName: t('poolMaintenance.column.name'),
        field: 'name',
        type: 'string',
        flex: 1
      },
      {
        headerName: t('poolMaintenance.column.description'),
        field: 'description',
        type: 'string',
        flex: 1
      }
    ],
    []
  );
};
